import { forwardRef } from 'react';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import Circle from '@/icons/circle.svg';
import { cn } from '@/utils';

const RadioGroup = forwardRef(({ className, value, error, ...props }, ref) => {
	return (
		<RadioGroupPrimitive.Root
			className={cn('grid gap-2', className)}
			{...props}
			ref={ref}
		/>
	);
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = forwardRef(({ className, ...props }, ref) => {
	return (
		<RadioGroupPrimitive.Item
			ref={ref}
			className={cn(
				'group-hover:-grey-300 aspect-square h-4 w-4 rounded-full border border-primary text-primary transition-colors focus:outline-none focus-visible:shadow-lg focus-visible:shadow-red focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 group-hover:border-grey-300',
				className
			)}
			{...props}
		>
			<RadioGroupPrimitive.Indicator className="flex items-center justify-center">
				<Circle className="h-2 w-2 fill-primary" />
			</RadioGroupPrimitive.Indicator>
		</RadioGroupPrimitive.Item>
	);
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
